

<template>
  <div class="globalheader">
    <div class="mainContainer disFlex between">
      <div class="gl-h-l disFlex">
        <div :class="activeFlag=='first'?activeClass:nameClass"><span @click="changeFlag('first')">产品介绍</span></div>
        <div :class="activeFlag=='second'?activeClass:nameClass"><span @click="changeFlag('second')">课程目录</span>
        </div>
        <div :class="activeFlag=='third'?activeClass:nameClass"><span @click="changeFlag('third')">课程附件</span></div>
        <div :class="activeFlag=='fourth'?activeClass:nameClass"><span @click="changeFlag('fourth')">评价</span></div>
      </div>
      <div class="gl-h-r disFlex">
        <span v-if="productInfo.isenroll=='0'&&productInfo.price>0">￥{{productInfo.price}}</span>
        <el-button v-if="productInfo.isenroll=='0'&&productInfo.price>0" type="primary"
          style="height: 44px;border-radius: 22px;width: 171px;" @click="toBuy()">购买课程
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CpxqHeader',
    props: ['activeFlag','currentUser'],
    data() {
      return {
        nameClass: 'flex1',
        activeClass: 'flex1 active',
        productInfo: {},
      }
    },
    methods: {
      changeFlag: function(flag) {
        this.$emit('changeCpitype', flag);
      },
      getData: function(id) {
        this.$axios.get('/kt/wz/productInfo/getProdcutallDetail.htm?id=' + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.productInfo = data.data;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      // 跳转订单信息页面
      toBuy: function() {
        this.$emit('changeHeader', true)
        if (!this.currentUser) {
          this.$router.push('/Login?productId=' + this.$route.query.id)
        } else {
          this.$router.push('/Order?id=' + this.$route.query.id);
        }
      },
    },
    created: function() {
      this.activeFlag = this.activeFlag;
      this.getData(this.$route.query.id);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .globalheader {
    background-color: #fff;
    height: 114px;
    position: fixed;
    top: 0;
    width: 100%;
  }

  .flex1 {
    line-height: 114px;
  }

  .flex1 span {
    display: inline-block;
    padding: 0 15px;
    height: 108px;
    cursor: pointer;
    transition: all 0.3s left;
    font-size: 18px;
    color: #333;
    font-weight: 500;
  }

  .flex1.active span {
    border-bottom: 3px solid #0071BA;
    color: #0071BA;
  }

  .gl-h-l {
    width: 792px;
  }

  .gl-h-r {
    color: #fff;
    line-height: 114px;
    display: flex;
    align-items: center;
  }

  .gl-h-r span {
    cursor: pointer;
    padding: 0 3px;
    color: #d50000;
    letter-spacing: 2px;
    font-size: 30px;
    font-family: 'DINAlternate, DINAlternate-Bold';
    font-weight: 700;
    padding-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CpxqHeader.vue